import moment from 'moment';
import React, { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { EventsFirestoreResponse } from 'src/types';

import { Card, Error, Spinner } from '../../components';
import { useGetEventsFromFirestore, useQueryHelper } from '../../queries';
import { useLanguageState, useOrganizationState } from '../../state';
import { Title } from './Events.styled';

export const Events: FC = () => {
  const { t } = useTranslation();
  const { organizationData } = useOrganizationState();
  const { language: currentLang } = useLanguageState();
  const hotelEventsCollections = useGetEventsFromFirestore(1, organizationData.hotel);
  const { data: events, refetch } = hotelEventsCollections;
  const { isLoading, isError } = useQueryHelper({ queries: [hotelEventsCollections] });
  const navigate = useNavigate();

  // eslint-disable-next-line max-len
  const filteredItems = events?.data?.sort((a, b) => moment(a.eventDate, 'YYYY/MM/DD').valueOf() - moment(b.eventDate, 'YYYY/MM/DD').valueOf()
  || moment(a.eventTimeFrom, 'HH:mm').valueOf() - moment(b.eventTimeFrom, 'HH:mm').valueOf());

  if (isLoading) {
    return <Spinner global />;
  }

  if (isError) {
    return <Error info errorTitle="Brak dostępnych wydarzeń" action={refetch} />;
  }

  return (
    <>
      <Helmet>
        <title>Hotelspot | Wydarzenia hotelowe</title>
        <meta name="description" content="Hotelspot - Wydarzenia hotelowe" />
      </Helmet>
      <Title> {t('events_screen.title')}</Title>
      <div className="grid sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-4">
        {!!filteredItems?.length && filteredItems?.map((event: EventsFirestoreResponse) => (
          <Card
            remainingEntries={event.remainingEntries}
            freeAccess={event.isOpen}
            time={`${event.eventTimeFrom} - ${event.eventTimeTo}`}
            key={event.id}
            date={event.eventDate}
            image={event.coverPhoto}
            title={event.title[currentLang]}
            action={() => navigate(`/event/${event.id}`)}
          />
        ))}
      </div>
    </>
  );
};
